<div class="dbs-confirm-dialog-container-v2">
  <div *ngIf="isDisplayHeader" class="header-dialog-custom">
    <div class="header-dialog-custom-title">{{ title | translate }}</div>
  </div>
  <div class="content-dialog-custom">
    <div *ngIf="!useInnerHTML" class="message flex justify-center items-center mb-3" [class.text-left]="messageLeft">
      {{ message | translate }}
    </div>
    <div
      *ngIf="useInnerHTML"
      class="message flex justify-center items-center mb-3"
      [class.text-left]="messageLeft"
      [innerHTML]="message | translate"
    ></div>

    <div mat-dialog-actions>
      <div class="btn-group flex justify-center items-center mb-3 gap-y-2 gap-x-8">
        <button *ngIf="type === 1" mat-flat-button type="button" class="btn-custom-white" (click)="onDismiss()">
          {{ cancelButtonText | translate }}
        </button>
        <button mat-flat-button type="button" class="btn-custom" (click)="onConfirm()">
          {{ confirmButtonText | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
